const SETTINGS_KEY = 'altessera:appSettings';
export const SETTINGS_CHANGED_EVENT = 'altessera:settings-changed';

const getStoredSettings = () => {
  try {
    if (typeof window === 'undefined') return {};
    const raw = window.localStorage.getItem(SETTINGS_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
};

const writeStoredSettings = (settings) => {
  try {
    if (typeof window === 'undefined') return;
    window.localStorage.setItem(SETTINGS_KEY, JSON.stringify(settings));
    window.dispatchEvent(new Event(SETTINGS_CHANGED_EVENT));
  } catch {}
};

export const getHomeWidgetEnabledIds = (defaultIds) => {
  const settings = getStoredSettings();
  if (!Array.isArray(settings.homeWidgetEnabledIds)) {
    return defaultIds;
  }
  return settings.homeWidgetEnabledIds;
};

export const setHomeWidgetEnabledIds = (ids) => {
  const settings = getStoredSettings();
  writeStoredSettings({ ...settings, homeWidgetEnabledIds: ids });
};

export const getDebugEnabled = () => {
  return Boolean(getStoredSettings().debugEnabled);
};

export const setDebugEnabled = (enabled) => {
  const settings = getStoredSettings();
  writeStoredSettings({ ...settings, debugEnabled: enabled });
};
